import { render, staticRenderFns } from "./NewsSinglePage.vue?vue&type=template&id=3baf0d04&scoped=true&"
import script from "./NewsSinglePage.vue?vue&type=script&lang=js&"
export * from "./NewsSinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf0d04",
  null
  
)

export default component.exports